<template>
  <div class="sm:col-span-6">
    <label class="block text-sm font-medium" for="frm-watermarkForm-watermarkForm-watermark_position">{{$t('Watermark placement')}}</label>
    <div class="w-3/4 mx-auto">
      <div class="WatermarkPlacement mt-2 flex flex-wrap relative">
        <div style="padding-bottom: 33%" class="bg-white w-1/2 h-0 relative" :class="{selected: wallpaper || position == 'LeftTop'}" @click="setPosition('LeftTop')">
          <span class="absolute left-2 top-2">{{$t('left top')}}</span>
        </div>
        <div style="padding-bottom: 33%" class="bg-white w-1/2 h-0 relative" :class="{selected: wallpaper || position == 'RightTop'}" @click="setPosition('RightTop')">
          <span class="absolute right-2 top-2">{{$t('right top')}}</span>
        </div>
        <div style="padding-bottom: 33%" class="bg-white w-1/2 h-0 relative" :class="{selected: wallpaper || position == 'LeftBottom'}" @click="setPosition('LeftBottom')">
          <span class="absolute left-2 bottom-2">{{$t('left bottom')}}</span>
        </div>
        <div style="padding-bottom: 33%" class="bg-white w-1/2 h-0 relative" :class="{selected: wallpaper || position == 'RightBottom'}" @click="setPosition('RightBottom')">
          <span class="absolute right-2 bottom-2">{{$t('right-bottom')}}</span>
        </div>
        <div
          style="padding-bottom: 33%"
          class="bg-whit w-1/2 h-0 absolute top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 bg-white"
          :class="{selected: wallpaper || position == 'Center'}" @click="setPosition('Center')"
        >
      <span
        class="absolute top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 "
      >{{$t('center center')}}</span
      >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    setPosition: function (position) {
      this.$formValues['frm-watermarkForm-watermarkForm-watermark_position'] = position
      this.$formValues['frm-watermarkForm-watermarkForm-watermark_wallpaper'] = false;
    },
  },
  computed: {
    position() {
      return this.$formValues['frm-watermarkForm-watermarkForm-watermark_position']
    },
    wallpaper() {
      return this.$formValues['frm-watermarkForm-watermarkForm-watermark_wallpaper']
    },
  },
};
</script>

<style lang="scss" scoped>
.WatermarkPlacement {
  > * {
    outline: 1px solid theme("colors.gray[200]");
    @apply cursor-pointer;
    @apply transition duration-300 ease-in-out;

    span {
      @apply text-sm text-gray-500;
    }

    &.selected {
      @apply bg-bc-blue;

      span {
        @apply text-white;
      }
    }

    &:hover:not(.selected) {
      @apply bg-bc-blue-light;
      span {
        @apply text-gray-500;
      }
    }
  }
}
</style>
